module.exports = __webpack_public_path__ + "media/images/pic/wave-8afa4beb351657f35fe00fac90112fb6.png";